import { forwardRef } from '@chakra-ui/react'
import React, { createElement, useMemo } from 'react'
import { Controller } from 'react-hook-form'
import Icon from '../../containers/Blocks/Icon'

import BaseEditor from './BaseEditor'

export const platforms = [
  { value: 'email', label: 'E-mail', pttn: 'xxx@gmail.com' },
  { value: 'facebook', label: 'Facebook', pttn: 'https://www.facebook.com/xxx' },
  { value: 'instagram', label: 'Instagram', at: true, pttn: 'https://www.instagram.com/xxx' },
  { value: 'line', label: 'Line@', pttn: 'https://line.me/R/xxx' },
  { value: 'twitter', label: 'Twitter', at: true, pttn: 'https://twitter.com/xxx' },
  { value: 'tiktok', label: 'Tiktok', at: true, pttn: 'https://www.tiktok.com/@xxx' },
  { value: 'youtube', label: 'Youtube', pttn: 'https://www.youtube.com/channel/xxx' },
  { value: 'twitch', label: 'Twitch', pttn: 'https://www.twitch.tv/xxx' },
  { value: 'discord', label: 'Discord', pttn: 'https://discord.gg/xxx' },
  { value: 'telegram', label: 'Telegram', pttn: 'https://t.me/xxx' },
  { value: 'flickr', label: 'Flickr', pttn: 'https://www.flickr.com/people/xxx' },
  { value: 'applePodcasts', label: 'Apple Podcasts', pttn: 'https://podcasts.apple.com/tw/podcast/xxx' },
  { value: 'spotify', label: 'Spotify', pttn: 'https://open.spotify.com/show/xxx' },
  { value: 'github', label: 'Github', pttn: 'https://github.com/xxx' },
  { value: 'medium', label: 'Medium', pttn: 'https://medium.com/@xxx' },
  { value: 'behance', label: 'Behance', pttn: 'https://www.behance.net/xxx' },
  { value: 'pinterest', label: 'Pinterest', pttn: 'https://www.pinterest.com/xxx' },
  { value: 'plurk', label: 'Plurk', pttn: 'https://www.plurk.com/xxx' },
  { value: 'blogger', label: 'Blogger', pttn: 'https://xxx.blogspot.com' },
  { value: 'linkedIn', label: 'LinkedIn', pttn: 'https://www.linkedin.com/in/xxx' },
  { value: 'vimeo', label: 'Vimeo', pttn: 'https://vimeo.com/xxx' },
]

const SocialLinksEditor = forwardRef(({ control, name }, ref) => {
  return platforms.map((plat) => (
    <Controller
      key={plat.value}
      control={control}
      name={`${name}.${plat.value}`}
      render={({ field }) => (
        <BaseEditor
          {...field}
          label={plat.label}
          leftIcon={p => createElement(Icon, p, plat.value)}
          control={control}
          placeholder={`${plat.at ? `@xxx or ` : ``}${plat.pttn}`}
          _placeholder={{ color: 'gray.100' }}
          _focus={{
            _placeholder: {
              color: 'gray.400'
            }
          }}
        />
      )}
    />
  ))
})

export default SocialLinksEditor
